export default __webpack_public_path__ + "static/media/Mardi Grad Project.8e23b721.png";